import {
  createDerivedTokenSendingAndJsonExpectingAlova,
  createDerivedTokenSendingAndBlobExpectingAlova,
  createDerivedTokenFormSendingAndJsonExpectingAlova,
} from '../services/alova'
import { useAuthStore } from '@/stores/auth'
import workers from '@/workers'

export function useAlova() {
  const store = useAuthStore()
  const tokenFn = () => store.token
  const json = createDerivedTokenSendingAndJsonExpectingAlova(tokenFn, store.logout, workers.syncWorker)
  const blob = createDerivedTokenSendingAndBlobExpectingAlova(tokenFn)
  const form = createDerivedTokenFormSendingAndJsonExpectingAlova(tokenFn, store.logout)
  return { json, blob, form }
}
